import React from 'react'
import {createContext} from 'react'

const AppContext = createContext()

export default AppContext